import * as React from "react";
import { titleName } from "../_constants/Code";
import { Message } from "../_components/MessagePage";

const NotFound = () => {
  const messageList = [
    "ページが見つかりませんでした。",
    "お探しのページはURLが間違っているか、削除された可能性があります。"
  ];
  // タイトル設定
  document.title = titleName.notFound + titleName.common;
  return (
    <Message
      title="ページが見つかりません"
      messageList={messageList}
      loginBtn={false}
      topBtn={true}
    />
  );
};

export default NotFound;
